import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import api from '../../services/api';
import './UserProfile.css';

// Ícones
const EditPencilIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
  </svg>
);

export default function UserProfile() {
  const { userName: paramUserName } = useParams();
  const { user: currentUser } = useContext(AuthContext);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMenuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const userNameToFetch = paramUserName || currentUser?.userName;

    if (!userNameToFetch) {
      // Se não há userName na URL e o usuário logado ainda não carregou, não faz nada.
      // O useEffect será re-executado quando currentUser for preenchido.
      return;
    }

    const fetchUser = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/users/${userNameToFetch}`);
        setUser(res.data);
      } catch (err) {
        if (err.response && err.response.status === 403) {
          setError(err.response.data.msg || 'Acesso negado.');
        } else {
          setError('Falha ao carregar dados do usuário.');
          console.error(err);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [paramUserName, currentUser]);

  const isOwnProfile = currentUser && user && currentUser.id === user.id;

  const handlePictureClick = () => {
    if (isOwnProfile) {
      setMenuOpen(!isMenuOpen);
    }
  };

  if (loading) {
    return <div className="profile-loading">Carregando perfil...</div>;
  }

  if (error) {
    return <div className="profile-error">{error}</div>;
  }

  if (!user) {
    return <div className="profile-error">Usuário não encontrado.</div>;
  }

  const getRoleLabel = role => {
    const roles = {
      STUDENT: 'Aluno',
      INSTRUCTOR: 'Instrutor',
      ADMIN_CLIENT: 'Admin (Cliente)',
      ADMIN_EAD: 'Admin (EAD)',
      SUPER_ADMIN: 'Super Admin',
      GUEST: 'Convidado',
    };
    return roles[role] || 'Desconhecido';
  };

  return (
    <div className="profile-page">
      <div className="container">
        <div className="profile-card">
          <div className="profile-header-background"></div>
          <div className="profile-content">
            <div className="profile-picture-wrapper">
              <div
                className={`profile-picture-container ${isOwnProfile ? 'editable' : ''}`}
                onClick={handlePictureClick}
              >
                <img
                  src={`https://ui-avatars.com/api/?name=${user.fullName.replace(' ', '+')}&background=8b5cf6&color=fff&size=256`}
                  alt={`Foto de ${user.fullName}`}
                  className="profile-picture"
                />
                {isOwnProfile && (
                  <div className="profile-picture-overlay">
                    <EditPencilIcon />
                  </div>
                )}
              </div>
              {isOwnProfile && isMenuOpen && (
                <div className="picture-menu">
                  <button className="menu-item">Visualizar foto</button>
                  <button className="menu-item">Editar foto</button>
                </div>
              )}
            </div>

            <div className="profile-details">
              <h1 className="profile-name">{user.fullName}</h1>
              <p className="profile-role">{getRoleLabel(user.role)}</p>
              {user.company && <p className="profile-company">Empresa: {user.company.name}</p>}
            </div>

            {isOwnProfile && (
              <div className="profile-actions">
                <button className="btn btn-primary">Editar Perfil</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
